var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"30","cy":"30","r":"30","fill":"white","className":"background","key":0}),React.createElement("circle",{"cx":"30","cy":"30","r":"29.5","stroke":"#red","strokeOpacity":"0.2","className":"border","key":1}),React.createElement("path",{"d":"M37 30H23","stroke":"#004914","strokeWidth":"2","strokeLinecap":"round","className":"arrowStick","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M30 37L23 30L30 23","stroke":"#004914","className":"arrowHead","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":3})]);
}

Arrow.defaultProps = {"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
